export const PAGE_LIMIT = 10;
export const FORMATS = "post, story, clips, carousel, swipe";
export const MEDIA_TYPES = "image, video";
export const DEFAULT_TABLE_STATE = "Ads";
export const FORMATS_LABEL = "Creative format";
export const MEDIA_TYPES_LABEL = "Creative media type";
export const FILTER_METADATA_OPTIONS = ["format", "media"];
export const TABLE_STATE_URL_PARAMS = ["adName", "brand"];
export const DEFAULT_SORT = { asc: false, desc: false };

const stringToList = (str: string) => str.split(",").map((option) => option.trim());
const FORMATS_LIST = stringToList(FORMATS);
const MEDIA_TYPES_LIST = stringToList(MEDIA_TYPES);

export const FILTER_OPTIONS = [
  { label: FORMATS_LABEL, value: FORMATS_LABEL, choices: FORMATS_LIST, isDisabled: false },
  { label: MEDIA_TYPES_LABEL, value: MEDIA_TYPES_LABEL, choices: MEDIA_TYPES_LIST, isDisabled: false },
];
